import React, { useEffect, useState } from "react";
// import { Button, Col, Form, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { addUpdateToken, getToken } from "../../redux/actions/settingActions";
import * as Icon from "react-bootstrap-icons";
import Toast from "../assetLibComponents/shared/Toast";



const SettingToken = (props) => {
  const dispatch = useDispatch();
  const fetchToken = useSelector((state) => state.setting.fetchToken);
  const [token, setToken] = useState(fetchToken?.details);
  const [tokenConfirm, setTokenConfirm] = useState("");
  const [tokenEdit, setTokenEdit] = useState(false);

  const submitHandler = () => {
    if(tokenEdit){
      if(token === tokenConfirm){
        dispatch(addUpdateToken(props.authToken, token));
      }
      else{
        Toast("Please Enter Same Token", "E");
      }
    }else{
      dispatch(addUpdateToken(props.authToken, token));
    }
  };

  useEffect(() => {
    dispatch(getToken(props.authToken, token));
  }, []);

  return (
    <>
      <div className="mt-5 ps-5 ms-3">
        <div className="mb-3">
          <div className="grid grid-cols-12">
            <div className="col-span-2 flex items-center">
              <label>Token</label>
            </div>
            <div className="col-span-6">
              <div className="mb-3">
              <div className="grid grid-cols-12">
                <div className="col-span-8">
                  <input
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                    type="email"
                    //ref={nameRef}
                    required
                    autoComplete="off"
                    placeholder="Token"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                  />
                </div>
              </div>
            </div>
            </div>
            
           {fetchToken?.details?.length > 0 && <div>
              <span className="flex items-center not-italic font-medium text-xs leading-6 text-[#64B6E7] cursor-pointer my-auto" onClick={()=>{setTokenEdit(true)}}>
                <Icon.PencilSquare className="mr-3" color="#64B6E7" />
                Edit
              </span>
            </div>}
          </div>
          {fetchToken?.details?.length > 0 && tokenEdit === true && <div className="my-4 grid grid-cols-12">
            <div className="col-span-2 flex items-center">
              <label>Confirm Token</label>
            </div>
            <div className="col-span-6">
              <div className="mb-3">
                <div className="grid grid-cols-12">
                  <div className="col-span-8">
                    <input
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                      type="text"
                      autoComplete="off"
                      required
                      placeholder="Confirm Token"
                      value={tokenConfirm}
                      onChange={(e) => setTokenConfirm(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>}
          {!fetchToken?.details?.length > 0 && <div className="ms-10 grid grid-cols-12">
            <div
              className="text-center p-2 rounded-[10px] w-25 mt-4 not-italic font-medium text-xs leading-6 text-[#ffffff] bg-[#64B6E7] cursor-pointer my-auto"
              variant="primary"
              onClick={submitHandler}
            >
              Sumbit
            </div>
          </div>}
          {fetchToken?.details?.length > 0 && tokenEdit === true &&<div className="grid grid-cols-12">
            <div
              className="text-center p-2 rounded-[10px] w-25 mt-4 not-italic font-medium text-xs leading-6 text-[#ffffff] bg-[#64B6E7] cursor-pointer my-auto"
              variant="primary"
              onClick={submitHandler}
            >
              Update
            </div>
          </div>}
        </div>
      </div>
    </>
  );
};

export default SettingToken;
